// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2LK_F","title":"ClientCherryInfo_title__u76AP","itemText":"ClientCherryInfo_itemText__2jLEb"};